import React from 'react';

const listingsData = [
    {
        id: 1,
        title: 'Downtown Office Space',
        description: 'Modern office space with great city views.',
        beforeImage: '/assets/images/listings/mess.jpg',
        afterImage: '/assets/images/listings/clean.jpg',
    },
    {
        id: 2,
        title: 'Cozy Family Home',
        description: '3-bedroom home in a quiet neighborhood.',
        beforeImage: '/assets/images/listings/mess.jpg',
        afterImage: '/assets/images/listings/clean.jpg',
    },
    {
        id: 3,
        title: 'Beachside Airbnb',
        description: 'Short-term rental with ocean views.',
        beforeImage: '/assets/images/listings/mess.jpg',
        afterImage: '/assets/images/listings/clean.jpg',
    },
];

function ListingCard({ title, description, beforeImage, afterImage }) {
    return (
        <div className="card mb-4 shadow-sm">
            <div className="d-flex">
                <div className="flex-fill me-2">
                    <img
                        src={beforeImage}
                        alt={`${title} - Before`}
                        className="img-fluid rounded"
                        style={{ height: '200px', objectFit: 'cover', width: '100%' }}
                    />
                    <div className="text-center mt-1 fw-semibold text-muted">Before</div>
                </div>
                <div className="flex-fill ms-2">
                    <img
                        src={afterImage}
                        alt={`${title} - After`}
                        className="img-fluid rounded"
                        style={{ height: '200px', objectFit: 'cover', width: '100%' }}
                    />
                    <div className="text-center mt-1 fw-semibold text-muted">After</div>
                </div>
            </div>
            <div className="card-body">
                <h5 className="card-title">{title}</h5>
                <p className="card-text">{description}</p>
            </div>
        </div>
    );
}

function Listings() {
    return (
        <main className="container my-5">
            <h1 className="mb-4 text-center">Our Work — Before & After</h1>
            {listingsData.map((listing) => (
                <ListingCard key={listing.id} {...listing} />
            ))}
        </main>
    );
}

export default Listings;
